import React from 'react';
import TabsContainer from '../components/TabsContainer/TabsContainer';
import { useParams } from 'react-router-dom';
import OverviewIcon from '@mui/icons-material/Visibility';
import StatsIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';
import UsersIcon from '@mui/icons-material/People';
import CardsIcon from '@mui/icons-material/CreditCard';
import GiftsIcon from '@mui/icons-material/Redeem';
import Overview from './PartnerInfoPages/Overview';
import Stats from './PartnerInfoPages/Stats';
import Settings from './PartnerInfoPages/Settings';
import Users from './PartnerInfoPages/Users';
import Cards from './PartnerInfoPages/Cards';
import Gifts from './PartnerInfoPages/Gifts';
import Orders from './PartnerInfoPages/Orders';
import { LocalOffer, Scanner, ShoppingCart } from '@mui/icons-material';
import Promotions from './PartnerInfoPages/Promotions';
import DetailDialog from '../components/DetailDialog/DetailDialog';
import QRScanner from '../components/QR/QRScqnner';
import { Box, Fab, styled, Tooltip } from '@mui/material';
import axios from 'axios';
import CardPointsAdd from './PartnerInfoPages/CardPointsAdd';

const StyledFab = styled(Fab)(({ theme }) => ({
    position: "fixed",
    bottom: 24,
    left: 76,
    boxShadow:
      "0 12px 20px -10px rgba(0, 188, 212, 0.28), 0 4px 20px 0 rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(0, 188, 212, 0.2)",
    backgroundImage: `linear-gradient(195deg, ${theme.palette.info.main}, ${theme.palette.info.dark})`,
    "&:hover": {
      backgroundImage: `linear-gradient(195deg, ${theme.palette.info.dark}, ${theme.palette.info.main})`,
      transform: "translateY(-2px)",
      boxShadow:
        "0 14px 26px -12px rgba(0, 188, 212, 0.42), 0 4px 23px 0 rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 188, 212, 0.2)",
    },
    transition: "all 0.2s ease-in-out",
  }))

// Function to generate a beep sound using the Web Audio API
const playBeep = () => {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)()
    const oscillator = audioContext.createOscillator()
    const gainNode = audioContext.createGain()
  
    oscillator.connect(gainNode)
    gainNode.connect(audioContext.destination)
  
    oscillator.type = "sine" // You can change the waveform type if desired
    oscillator.frequency.setValueAtTime(440, audioContext.currentTime) // Frequency in Hz (A4 note)
    gainNode.gain.setValueAtTime(0.5, audioContext.currentTime) // Volume
  
    oscillator.start()
    oscillator.stop(audioContext.currentTime + 0.2) // Beep duration of 200ms
  }

const PartnerInfo = ({idPartner = null}) => {
    const [openReader, setOpenReader] = React.useState(false);
    const [openAddPoints, setOpenAddPoints] = React.useState(false);
    const [idCard, setIdCard] = React.useState(null);
    const [cardUser, setCardUser] = React.useState(null);
    //const { id } = idPartner ? { id: idPartner } : useParams();
    const { id } = useParams();
    console.log(id);

    const handleScanSuccess = async (decodedText) => {
        playBeep()
        setOpenReader(false)
        //alert(decodedText)
        const res = await axios.get("/api/v2/partner/"+id+"/clients/"+decodedText)
        console.log(res);
        if (res.status === 200) {
            console.log(res.data);
            // Handle the response data as needed
            if (res.data && res.data.Cards && res.data.Cards.length > 0) {
                console.log("Card ID:", res.data.Cards[0].id);
                setIdCard(res.data.Cards[0].id);
                setCardUser(res.data.name);
                setOpenAddPoints(true);
            } else {
                console.error("No cards found for this user.");
            }
        } else {
            console.error("Error fetching data:", res.statusText);
        }
    }
    
      const handleScanFailure = (error) => {
        // console.warn("Scan failure:", error) 
      }

    const pages = [
        { title: 'Overview', component: <Overview id={id} />, icon: <OverviewIcon /> },
        { title: 'Stats', component: <Stats id={id} />, icon: <StatsIcon /> },
        { title: 'Users', component: <Users id={id} />, icon: <UsersIcon /> },
        { title: 'Cards', component: <Cards id={id} />, icon: <CardsIcon /> },
        { title: 'Gifts', component: <Gifts id={id} />, icon: <GiftsIcon /> },
        { title: 'Orders', component: <Orders id={id} />, icon: <ShoppingCart /> },
        { title: 'Promotions', component: <Promotions id={id} />, icon: <LocalOffer /> },
        { title: 'Settings', component: <Settings id={id} />, icon: <SettingsIcon /> }
    ];

    return (
        <div>
            <TabsContainer pages={pages} />
            <Tooltip title="Scan QR Code" placement="right" arrow>
                <StyledFab color="info" aria-label="scan" onClick={() => setOpenReader(true)} size="medium">
                    <Scanner />
                </StyledFab>
            </Tooltip>
            {openReader && <DetailDialog open={openReader} title={"QR Reader"} fullScreen={false}>
                <Box sx={{ p: 2 }}>
                    {openReader && <QRScanner 
                      key={"someUniqueId"} 
                      onScanSuccess={handleScanSuccess} 
                      onClose={() => setOpenReader(false)}
                      onScanFailure={handleScanFailure} 
                    />}
                </Box>
            </DetailDialog>}
            <DetailDialog open={openAddPoints} title={"Add points"} onClose={() => setOpenAddPoints(false)} fullScreen={false}>
                <Box sx={{ p: 2 }}>
                <CardPointsAdd partnerId={id} name={cardUser} idCard={idCard} onSave={()=>setOpenAddPoints(false)} onCancel={()=>setOpenAddPoints(false)} />
                </Box>
            </DetailDialog>
        </div>
    );
};

export default PartnerInfo;